<template>
    <button class="bg-a-orange-fe5000 text-white rounded-full px-10 font-main text-14" :class="[btnClass]"
        :disabled="disabled" @click="clickLine()">
        <div class="flex items-center gap-2.5">
            <img src="@/assets/icon/ic-line.svg" alt=""/>
            <div>
                เปิดแอพไลน์
            </div>
        </div>
    </button>
</template>
<script>
import ConfigManager from '@/config/ConfigManager';

export default {
    name: "OrangeButton",
    props: {
        customClass: { type: String, default: null },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        btnClass: function () {
            if (this.customClass != null) {
                return this.customClass;
            }
            return "p-2";
        }
    },
    setup: function () {
        const lineId = ConfigManager.getLineId()
        let urlSchemeOpenLine = "https://line.me/R/ti/p/" + lineId

        const clickLine = function () {
            window.location = urlSchemeOpenLine
        }

        return {
            clickLine
        }
    }
};
</script>
